import { useLocalization } from "../context/LocalizationContext";

const PageNotFound = () => {
   const { t: localization } = useLocalization();

  return (
    <div style={{ minHeight: 'calc(100vh - 56px)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <div className="page-not-found">
        <h1 className="text-center">404</h1>
        <h2 className="text-center">{localization("page_not_found")}</h2>
        <p className="text-center">{localization("page_not_found_message")}</p>
      </div>
    </div>
  );
}

export default PageNotFound;